import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { PaymentService } from '../services/payment.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { IntegrationVersionEnum } from '../models/liability-data.model';

@Injectable({ providedIn: 'root' })
export class OnlyBalanceResolver implements Resolve<boolean> {
  constructor(private paymentService: PaymentService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return (
      !!environment.onlyBalanceBillers?.includes(this.paymentService.payment.biller) &&
      this.paymentService.payment.integrationVersion === IntegrationVersionEnum.V1
    );
  }
}
